import React from 'react';
import * as ReactIcons from '@/components/Icons/ReactIconsMap';
import { ReactSVGIconProps } from '@/components/Icons/ReactIconsMap';


type CustomReactIconProps = ReactSVGIconProps & React.SVGProps<SVGSVGElement>;

const CustomReactIcon: React.FC<CustomReactIconProps> = ({
                                                           tag,
                                                           attr = {},
                                                           child = [],
                                                           ...props
                                                         }: CustomReactIconProps) => {
  return React.createElement(
    tag,
    { ...attr, ...props },
    child.map((node, index) => <CustomReactIcon {...node} key={index} />)
  )
}

export const GoTaskList = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.GoTaskListIconProps} {...props} />
export const PiCalendarX = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.PiCalendarXIconProps} {...props} />
export const LiaCommentsSolid = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.LiaCommentsSolidIconProps} {...props} />
export const MdOutlineShowChart = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.MdOutlineShowChartIconProps} {...props} />
export const BsClipboardCheck = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.BsClipboardCheckIconProps} {...props} />
export const RiCalendarScheduleLine = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.RiCalendarScheduleLineProps} {...props} />
export const CuDropdownIcon = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.CuDropdownIconProps} {...props} />
export const CuTextIcon = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.CuTextIconProps} {...props} />
export const CuTextareaIcon = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.CuTextareaIconProps} {...props} />
export const CuCheckboxIcon = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.CuCheckboxIconProps} {...props} />
export const CuCalendarIcon = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.CuCalendarIconProps} {...props} />
export const CuNumberIcon = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.CuNumberIconProps} {...props} />
export const GenerateTextSparkIcon = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.GenerateTextSparkIconProps} {...props} />
export const SparkOneIcon = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.SparkOneIconProps} {...props} />
export const EuroSymbolIcon = (props: React.SVGProps<SVGSVGElement>) =>
  <CustomReactIcon {...ReactIcons.EuroSymbolIconProps} {...props} />

